import { Color } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface HighlightProps {
  top: number;
  left: number;
  bottom: number;
  right: number;
  fillHighlight?: boolean;
  fillColor?: Color;
  drawOutline?: boolean;
  outlineColor?: Color | string;
  padded?: boolean;
}

type DocumentHighlightProps = HighlightProps & {
  children?: ReactNode;
};

const PADDING_CONSTANT = 0.15;

const Highlight = styled('div')<HighlightProps>`
  position: absolute;
  top: ${({ top, padded }) => `${top * 100 - (padded ? PADDING_CONSTANT : 0)}%`};
  left: ${({ left, padded }) => (padded ? `${left * 100 - PADDING_CONSTANT}%` : `${left * 100}%`)};
  height: ${({ top, bottom, padded }) =>
    padded ? `${(bottom - top) * 100 + 2 * PADDING_CONSTANT}%` : `${(bottom - top) * 100}%`};
  width: ${({ right, left, padded }) =>
    padded ? `${(right - left) * 100 + 2 * PADDING_CONSTANT}%` : `${(right - left) * 100}%`};
  ${({ fillHighlight, fillColor }) => fillHighlight && fillColor && `background: ${fillColor};`}
  outline: 2px solid;
  ${({ drawOutline, outlineColor }) =>
    drawOutline && outlineColor ? `outline: 2px solid ${outlineColor};` : 'outline: none;'}
  border-radius: 4px;
  mix-blend-mode: normal;
`;

const DocumentHighlight = (props: DocumentHighlightProps) => {
  const { children, ...highlightProps } = props;
  return <Highlight {...highlightProps}>{children}</Highlight>;
};

export default DocumentHighlight;
